
import axiosInstance from "../Utils/axiosInterceptor";
import {User} from "../models/User";


export class AuthenticationService {

    static async signIn(data: any): Promise<User> {
        try {
            const response = await axiosInstance.post<User>('/log_in/', data, { skipAuthRefresh: true });
            return response.data;
        } catch (error) {
            console.error('Sign in failed:', error);
            throw error;
        }
    }

    static async register(user: User) {
        try {
            const response = await axiosInstance.post<User>("/register/", user);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getUserProfile(): Promise<User> {
        try {
            const response = await axiosInstance.get<User>("/get_user/");
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async googleSignIn(param: { idToken: string }) {
        return undefined;
    }

    static async getUserByPhone(phone: string ) {
        try {
            const response = await axiosInstance.get<User>("/get_user_by_phone/"+phone);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async sendPasswordResetCodeBySms(phone: string) {
        try {
            const response = await axiosInstance.get<User>("/send_password_reset_code_by_sms/"+phone);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async verifyOtp(otp: string[], currentUser: User) {

        console.log({"otp":otp.join(""), "user":currentUser})

        try {
            const response = await axiosInstance.post<User>("/verify_otp/",{"otp":otp.join(""), "user":currentUser});
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async updatePassword(user: User, password: string) {
        try {
            const response = await axiosInstance.post<User>("/update_password/",{"user":user, "password":password});
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async sendPasswordResetCodeByEmail(email: string) {
        try {
            const response = await axiosInstance.get<User>("/send_password_reset_code_by_email/"+email);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async sendPhoneVerificationCodeBySms(phone: string) {
        try {
            const response = await axiosInstance.post("/send_phone_verification_code_by_sms/",{"phone":phone});
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    static async verifyRegisterOtp(otp: string) {
        try {
            const response = await axiosInstance.post("/verify_register_otp/",{"otp":otp});
            return response.data;
        } catch (error) {
            console.error('Failed to fetch User:', error);
            throw error;
        }
    }

    // ── Upload any file, returns { url, path } ────────────────────────────
    static async uploadFile(file: File): Promise<{ url: string; path: string }> {
        try {
            const formData = new FormData();
            formData.append('file', file);
            const response = await axiosInstance.post('/upload_file/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // ── Register driver — backend creates user + bank account ─────────────
    static async registerDriver(user: User): Promise<void> {
        try {
            await axiosInstance.post('/register_driver/', user);
        } catch (error) {
            throw error;
        }
    }

    static async deleteAccount() {
        try {
            await axiosInstance.post('/register_driver/', {});
        } catch (error) {
            throw error;
        }
    }

    static async registerSeller(data: any): Promise<void> {
        try {
            await axiosInstance.post('/register_seller/', data);
        } catch (error) {
            throw error;
        }
    }
}